module.exports = __webpack_public_path__ + "img/2025big1.9f85aa13.jpg";